<template>
  <div>
    <div id="cesium-container" ref="cesiumContainer">
      <div class="info-distances" v-if="this.infoDistances">
        {{ this.infoDistances }}
      </div>
      <div class="menu-item">
        <v-btn
          class="cesium-button"
          dark
          height="32px"
          v-on:click="openListSatellite()"
        >
          Choose satellite
        </v-btn>
        <v-list
          dark
          v-if="displayListSatellites"
          style="width: 95%; margin: auto"
        >
          <v-list-item
            v-for="(item, index) in satellitesDatas"
            :key="index"
            :value="index"
            v-on:click="targetSatellite(item.name)"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>

        <div>
          <DescriptionCard :text="description"></DescriptionCard>
        </div>
        <cesium-recorder ref="cesiumRecorder" />
        <cesium-lighting-button ref="cesiumLightingButton" />
        <OverlayComponent :elementToOverlay="timelineContainer"
          ><CesiumMarkerOverlay
            :startDate="timelineDates[0].date"
            :endDate="timelineDates[timelineDates.length - 1].date"
            :markers="timelineDates"
            v-on:changeDate="setTimeFromUTC($event)"
        /></OverlayComponent>
      </div>
    </div>
  </div>
</template>

<script>
import DescriptionCard from '../../components/Toolbox/DescriptionCard.vue'
import axios from '../../services/axios'
import Vue, { onBeforeMount } from 'vue'
import VueAxios from 'vue-axios'
import { CesiumInitialization } from '../../components/ThreeD/CesiumInitialization'
import { AnalyticalOrbit } from '../../components/ThreeD/AnalyticalOrbit'
import CesiumRecorder from '../../components/ThreeD/CesiumRecorder.vue'
import CesiumLightingButton from '../../components/ThreeD/CesiumLightingButton.vue'
import CesiumMarkerOverlay from '../Asterx/CesiumMarkerOverlay'
import OverlayComponent from '../Asterx/OverlayComponent'
import * as Cesium from 'cesium'

Vue.use(VueAxios, axios)

export default {
  name: 'ScreeningCatalogueAnalysisEventsCesiumVisualizer',

  mixins: [CesiumInitialization, AnalyticalOrbit],

  props: {
    satellitesDatas: {
      type: Array
    },
    timelineDates: {
      type: Array
    },
    description: { type: String }
  },

  components: {
    'cesium-recorder': CesiumRecorder,
    'cesium-lighting-button': CesiumLightingButton,
    CesiumMarkerOverlay: CesiumMarkerOverlay,
    OverlayComponent: OverlayComponent,
    DescriptionCard
  },

  data() {
    return {
      isViewerLoading: false,
      satellitesDS: null,
      traceDS: null,
      linesBetweenSatellitesDS: null,
      planTosatellitesDS: null,
      removeEventListenerCallback: null,
      timelineContainer: null,
      normalPlanesDatas: [],
      distancesLines: [],
      infoDistances: null,
      displayListSatellites: false
    }
  },

  watch: {
    satellitesDatas() {
      this.resetSatellites()
      this.resetTraces()
      this.resetLinesBetweenSatellites()
      this.resetPlanToSatellites()
      this.resetClockEventListener()
    }
  },

  async mounted() {
    this.isViewerLoading = true
    this.initializeViewer(true, true, false, false, false, true)
    this.insertElementInToolbar(this.$refs.cesiumLightingButton.$el)
    this.insertElementInToolbar(this.$refs.cesiumRecorder.$el)
    this.satellitesDS = new Cesium.CustomDataSource()
    this.viewer.dataSources.add(this.satellitesDS)
    this.traceDS = new Cesium.CustomDataSource()
    this.viewer.dataSources.add(this.traceDS)
    this.linesBetweenSatellitesDS = new Cesium.CustomDataSource()
    this.viewer.dataSources.add(this.linesBetweenSatellitesDS)
    this.planTosatellitesDS = new Cesium.CustomDataSource()
    this.viewer.dataSources.add(this.planTosatellitesDS)
    this.viewer.clock.shouldAnimate = true
    this.setCesiumClock(
      this.julianDate(this.timelineDates[0].date),
      this.julianDate(this.timelineDates[this.timelineDates.length - 1].date)
    )
    this.viewer.clock.onTick.addEventListener(this.computeIcrfToFixed)
    this.computeIcrfToFixed(this.viewer.clock, true)
    this.viewer.scene.render(this.viewer.clock.currentTime)
    this.initSatellites()
    this.initTraceSatellite()
    this.initLineBetweenSatellite()
    this.initClockEventListener()
    this.initPlanToSatellites()
    this.timelineContainer = this.viewer.timeline.container
    this.isViewerLoading = false
  },
  beforeDestroy() {
    this.removeEventListenerCallback()
  },
  methods: {
    openListSatellite() {
      if (this.displayListSatellites) {
        this.displayListSatellites = false
      } else {
        this.displayListSatellites = true
      }
    },
    julianDates(dates) {
      return dates.map((sampleTime) =>
        Cesium.JulianDate.fromIso8601(sampleTime)
      )
    },

    julianDate(date) {
      return Cesium.JulianDate.fromIso8601(date)
    },

    initClockEventListener() {
      this.removeEventListenerCallback =
        this.viewer.clock.onTick.addEventListener((clock) => {
          this.updateInfo(clock)
        }, this)
    },

    updateInfoPlane(clock, indexSatellite, indexPlane) {
      const plane = this.satellitesDatas[indexSatellite].planes[indexPlane]
      let text = ''
      for (let k = 0; k < plane.distancePoints.length; k++) {
        let posObject = this.getPositionSatelliteInertial(
          plane.distancePoints[k],
          clock.currentTime
        )
        const normalVector = this.normalPlanesDatas[indexSatellite][indexPlane]
        const satellitePos = this.getPositionSatelliteInertial(
          this.satellitesDatas[indexSatellite].name,
          clock.currentTime
        )
        if (posObject != null && normalVector != null && satellitePos != null) {
          let distance = this.getDistanceToPlan(normalVector, posObject)
          text += this.displayDistancePlan(distance, plane, indexSatellite, k)
        }
      }
      return text
    },
    getDistanceToPlan(normalVector, positionSatellite) {
      return Cesium.Cartesian3.dot(normalVector, positionSatellite) / 1000
    },
    displayDistancePlan(distance, plane, indexSatellite, indexSecondSatellite) {
      let textDistanceToPlane = ''
      let textDefinitionPlane = ''
      if (distance < 0) {
        distance = -distance
      }
      if (plane.firstPoint == 'Past') {
        textDefinitionPlane = this.satellitesDatas[indexSatellite].name
      } else {
        textDefinitionPlane = plane.firstPoint + '/' + plane.secondPoint
      }
      textDistanceToPlane = ` ${
        plane.distancePoints[indexSecondSatellite]
      } / Plane of ${textDefinitionPlane} : ${distance.toFixed(3)} km`
      return textDistanceToPlane
    },

    updateInfoDistance(clock, indexSatellite, indexLine) {
      let text = ''
      let distance =
        this.distancesLines[indexLine].getValue(clock.currentTime) / 1000

      text +=
        this.satellitesDatas[indexSatellite].name +
        ' --> ' +
        this.satellitesDatas[indexSatellite].lines[indexLine].pointName +
        ' : ' +
        distance.toFixed(3) +
        'km'
      return text
    },
    updateInfo(clock) {
      let displayText = ''

      for (let i = 0; i < this.satellitesDatas.length; i++) {
        if (this.satellitesDatas[i].planes != null) {
          for (let j = 0; j < this.satellitesDatas[i].planes.length; j++) {
            displayText += this.updateInfoPlane(clock, i, j)
          }
        }

        if (this.satellitesDatas[i].lines != null) {
          for (let j = 0; j < this.satellitesDatas[i].lines.length; j++) {
            displayText += this.updateInfoDistance(clock, i, j)
          }
        }
        this.infoDistances = displayText
      }
    },

    resetClockEventListener() {
      if (this.removeEventListenerCallback != null) {
        this.removeEventListenerCallback()
      }
      this.initClockEventListener()
    },

    initSatellites() {
      for (let i = 0; i < this.satellitesDatas.length; i++) {
        this.satellitesDS.entities.add(
          this.initSatEntity(
            this.satellitesDatas[i].positions,
            this.julianDates(this.satellitesDatas[i].dates),
            this.satellitesDatas[i].name,
            this.satellitesDatas[i].color
          )
        )
      }
    },

    resetSatellites() {
      this.isViewerLoading = true
      this.satellitesDS.entities.removeAll()
      this.initSatellites()
      this.setCesiumClock(
        this.julianDate(this.timelineDates[0].date),
        this.julianDate(this.timelineDates[this.timelineDates.length - 1].date)
      )
      this.isViewerLoading = false
    },

    initSatEntity(satPositions, sampleTimes, satName, color) {
      const sampledPositions = this.createPositionsProperty(
        satPositions,
        sampleTimes,
        Cesium.ReferenceFrame.INERTIAL
      )

      return new Cesium.Entity({
        id: satName,
        description: satName,
        position: sampledPositions,
        show: true,
        billboard: {
          eyeOffset: Cesium.Cartesian3(0, 0, 0),
          image:
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADJSURBVDhPnZHRDcMgEEMZjVEYpaNklIzSEfLfD4qNnXAJSFWfhO7w2Zc0Tf9QG2rXrEzSUeZLOGm47WoH95x3Hl3jEgilvDgsOQUTqsNl68ezEwn1vae6lceSEEYvvWNT/Rxc4CXQNGadho1NXoJ+9iaqc2xi2xbt23PJCDIB6TQjOC6Bho/sDy3fBQT8PrVhibU7yBFcEPaRxOoeTwbwByCOYf9VGp1BYI1BA+EeHhmfzKbBoJEQwn1yzUZtyspIQUha85MpkNIXB7GizqDEECsAAAAASUVORK5CYII=',
          pixelOffset: Cesium.Cartesian2(0, 0),
          scale: 1.5,
          show: true
        },
        label: {
          text: satName,
          font: '16px Helvetica',
          fillColor: color,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 2,
          pixelOffset: new Cesium.Cartesian2(0, 20),
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            5e4,
            3e7
          )
        }
      })
    },

    createPositionsProperty(positions, sampleTimes, referenceFrame) {
      const sampledPositionProperty = new Cesium.SampledPositionProperty(
        referenceFrame
      )
      sampledPositionProperty.setInterpolationOptions(
        Cesium.LagrangePolynomialApproximation,
        5
      )

      sampledPositionProperty.addSamples(
        sampleTimes,
        positions.map(
          (position) =>
            new Cesium.Cartesian3(position[0], position[1], position[2])
        )
      )

      return sampledPositionProperty
    },
    setTimeFromUTC(date) {
      this.viewer.clock.currentTime = Cesium.JulianDate.fromIso8601(date)
    },
    getPositionSatelliteInertial(idSatellite, time) {
      return this.satellitesDS.entities
        .getById(idSatellite)
        .position.getValueInReferenceFrame(time, Cesium.ReferenceFrame.INERTIAL)
    },
    getPositionSatelliteFixed(idSatellite, time) {
      return this.satellitesDS.entities
        .getById(idSatellite)
        .position.getValueInReferenceFrame(time, Cesium.ReferenceFrame.FIXED)
    },
    getNormalVectorFromThreePoint(
      firstPointPosition,
      secondPointPosition,
      thirdPointPosition
    ) {
      let firstVector = new Cesium.Cartesian3(
        secondPointPosition.x - firstPointPosition.x,
        secondPointPosition.y - firstPointPosition.y,
        secondPointPosition.z - firstPointPosition.z
      )
      let secondVector = new Cesium.Cartesian3(
        thirdPointPosition.x - secondPointPosition.x,
        thirdPointPosition.y - secondPointPosition.y,
        thirdPointPosition.z - secondPointPosition.z
      )
      let normalVector = new Cesium.Cartesian3.cross(
        firstVector,
        secondVector,
        new Cesium.Cartesian3()
      )
      return normalVector
    },
    normalizeVector(vector) {
      return new Cesium.Cartesian3.normalize(
        vector.clone(),
        new Cesium.Cartesian3()
      )
    },
    frameInertialToEastNorthUp(vector, thirdPointPosition) {
      let transformFixeToInertial = Cesium.Transforms.computeIcrfToFixedMatrix(
        this.viewer.clock.currentTime,
        new Cesium.Matrix3()
      )
      if (transformFixeToInertial != null) {
        //fix bug cesium
        let vectorConverted = Cesium.Matrix3.multiplyByVector(
          transformFixeToInertial,
          vector,
          new Cesium.Cartesian3()
        )

        let transform =
          Cesium.Transforms.eastNorthUpToFixedFrame(thirdPointPosition)
        let inv = Cesium.Matrix4.inverseTransformation(
          transform,
          new Cesium.Matrix4()
        )

        vectorConverted = Cesium.Matrix4.multiplyByPoint(
          inv,
          vectorConverted,
          new Cesium.Cartesian3()
        )
        return vectorConverted
      } else {
        return vector
      }
    },
    getThreePointFromPlane(plane, indexSatellite) {
      const sampledVelocity = this.createPositionsProperty(
        this.satellitesDatas[indexSatellite].velocity,
        this.julianDates(this.satellitesDatas[indexSatellite].dates),
        Cesium.ReferenceFrame.INERTIAL
      )
      let firstPointPosition
      let secondPointPosition
      let thirdPointPosition
      if (plane.firstPoint == 'Past') {
        firstPointPosition = sampledVelocity.getValueInReferenceFrame(
          this.viewer.clock.currentTime,
          Cesium.ReferenceFrame.INERTIAL
        )
      } else {
        firstPointPosition = this.getPositionSatelliteInertial(
          plane.firstPoint,
          this.viewer.clock.currentTime
        )
      }

      secondPointPosition = this.getPositionSatelliteInertial(
        plane.secondPoint,
        this.viewer.clock.currentTime
      )
      if (plane.origin == 'Earth') {
        thirdPointPosition = new Cesium.Cartesian3(0.001, 0.001, 0.001)
      } else {
        thirdPointPosition = this.getPositionSatelliteInertial(
          plane.origin,
          this.viewer.clock.currentTime
        )
      }

      return [firstPointPosition, secondPointPosition, thirdPointPosition]
    },
    getPlanesProperties(indexSatellite, indexPlane) {
      let plane = this.satellitesDatas[indexSatellite].planes[indexPlane]
      return new Cesium.CallbackProperty(() => {
        let threePoint = this.getThreePointFromPlane(plane, indexSatellite)

        let normalVector = new Cesium.Cartesian3(1, 1, 1)
        let normalVectorInFrameEastNorthUp = new Cesium.Cartesian3(1, 1, 1)
        if (
          threePoint[0] != null &&
          threePoint[1] != null &&
          threePoint[2] != null
        ) {
          normalVector = this.getNormalVectorFromThreePoint(
            threePoint[0],
            threePoint[1],
            threePoint[2]
          )
          normalVectorInFrameEastNorthUp = this.frameInertialToEastNorthUp(
            normalVector,
            threePoint[2]
          )
        }
        this.normalPlanesDatas[indexSatellite][indexPlane] =
          this.normalizeVector(normalVector)

        return new Cesium.Plane(
          this.normalizeVector(normalVectorInFrameEastNorthUp),
          0.0
        )
      }, false)
    },
    getDimensionPlane(plane, indexSatellite) {
      return new Cesium.CallbackProperty(() => {
        const threePoint = this.getThreePointFromPlane(plane, indexSatellite)
        if (
          threePoint[0] != undefined &&
          threePoint[1] != undefined &&
          threePoint[2] != undefined
        ) {
          return new Cesium.Cartesian2(40000000.0, 40000000.0)
        } else {
          return new Cesium.Cartesian2(0.0001, 0.0001)
        }
      }, false)
    },
    getOriginPlane(plane) {
      return new Cesium.CallbackProperty(() => {
        let originPosition
        if (plane.origin == 'Earth') {
          originPosition = new Cesium.Cartesian3(0.001, 0.001, 0.001)
        } else {
          originPosition = this.getPositionSatelliteInertial(
            plane.origin,
            this.viewer.clock.currentTime
          )
        }
        if (originPosition != undefined) {
          return originPosition
        } else {
          return Cesium.Cartesian3(0.001, 0.001, 0.001)
        }
      }, false)
    },
    initPlanToSatellites() {
      for (let i = 0; i < this.satellitesDatas.length; i++) {
        this.normalPlanesDatas.push([])
        if (this.satellitesDatas[i].planes != null) {
          for (let j = 0; j < this.satellitesDatas[i].planes.length; j++) {
            this.normalPlanesDatas[i].push(null)

            let planesProperties = this.getPlanesProperties(i, j)

            let dimensionPlane = this.getDimensionPlane(
              this.satellitesDatas[i].planes[j],
              i,
              j
            )

            let originPlane = this.getOriginPlane(
              this.satellitesDatas[i].planes[j]
            )

            this.planTosatellitesDS.entities.add({
              position: originPlane,
              plane: {
                plane: planesProperties,
                dimensions: dimensionPlane,
                material: this.satellitesDatas[i].color.withAlpha(0.5)
              }
            })
          }
        }
      }
    },
    initTraceSatellite() {
      for (let i = 0; i < this.satellitesDatas.length; i++) {
        if (this.satellitesDatas[i].orbitLine === true) {
          this.traceDS.entities.add({
            polyline: {
              positions: this.julianDates(this.satellitesDatas[i].dates).map(
                (date) =>
                  this.getPositionSatelliteFixed(
                    this.satellitesDatas[i].name,
                    date
                  )
              ),
              width: 2,
              material: this.satellitesDatas[i].color
            }
          })
        }
      }
    },
    initLineBetweenSatellite() {
      for (let i = 0; i < this.satellitesDatas.length; i++) {
        if (this.satellitesDatas[i].lines != null) {
          for (let j = 0; j < this.satellitesDatas[i].lines.length; j++) {
            this.distancesLines.push(new Cesium.SampledProperty(Number))
            this.distancesLines[j].addSamples(
              this.julianDates(this.satellitesDatas[i].dates),
              this.satellitesDatas[i].lines[j].relativeDistanceEphemerides
            )
            this.linesBetweenSatellitesDS.entities.add({
              polyline: {
                positions: new Cesium.CallbackProperty(() => {
                  let firstPointPosition = this.getPositionSatelliteFixed(
                    this.satellitesDatas[i].name,
                    this.viewer.clock.currentTime
                  )
                  let secondPointPosition = this.getPositionSatelliteFixed(
                    this.satellitesDatas[i].lines[j].pointName,
                    this.viewer.clock.currentTime
                  )
                  if (
                    firstPointPosition != null &&
                    secondPointPosition != null
                  ) {
                    return [firstPointPosition, secondPointPosition]
                  } else {
                    return [
                      new Cesium.Cartesian3(0.001, 0.001, 0.001),
                      new Cesium.Cartesian3(0.002, 0.001, 0.001)
                    ]
                  }
                }, false),
                width: 3,
                material: new Cesium.PolylineDashMaterialProperty({
                  color: Cesium.Color.BLUE,
                  dashLength: 8.0
                })
              }
            })
          }
        }
      }
    },
    resetTraces() {
      this.isViewerLoading = true
      this.traceDS.entities.removeAll()
      this.initTraceSatellite()
      this.isViewerLoading = false
    },
    resetLinesBetweenSatellites() {
      this.isViewerLoading = true
      this.linesBetweenSatellitesDS.entities.removeAll()
      this.initLineBetweenSatellite()
      this.isViewerLoading = false
    },
    resetPlanToSatellites() {
      this.isViewerLoading = true
      this.planTosatellitesDS.entities.removeAll()
      this.initPlanToSatellites()
      this.isViewerLoading = false
    },

    targetSatellite(name) {
      this.viewer.trackedEntity = this.satellitesDS.entities.getById(name)
    }
  }
}
</script>

<style scoped>
#cesium-container {
  position: relative;
  height: 500px;
  width: 100%;
  z-index: 2;
}

.info-distances {
  display: block;
  width: 40%;
  position: absolute;
  background: white;
  color: blue;
  padding: 4px;
  border-radius: 5px;
  z-index: 11;
  top: 5px;
  left: 5px;
}
.menu-item {
  position: absolute;
  align-items: end;
  z-index: 10;
  top: 40px;
  right: 5px;
}
</style>
